import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    private _http: HttpClient
  ) {
  }

  api = true;

  apistr = '/api/veexinc/veexweb';

  countries: any;

  getprgid(req: { type: string; email: string; part_no: string; program_id?: string; }): any {
    // console.log(req);
    return this._http.post('/api/veexinc/prgid', req);
  }
  postHubspotForm(id: string, body: any): any {
    return this._http.post('/submissions/v3/integration/secure/submit/6308132/' + id, body);
  }

  // API
  veExAPI(req: any): any {
    console.log(req);
    return this._http.post(this.apistr, req);
  }
  // Single Dl
  getSingleDownload(pn: string | string[]): Observable<any> {
    const download = {
      type: 'download_list',
      chassis_name: '',
      exclude_pn: '',
      only_pn: pn
    };
    // console.log(download);
    return this._http.post(this.apistr, download);
  }

  // getCountry(): any {
  //   if(!this.countries){
  //     console.log('loaded countries');
      
  //     const countrypass = {
  //       type: 'country_list',
  //       country: 'all'
  //     };
  //     const temp = this._http.post(this.apistr, countrypass);
  //     this.countries = temp;
  //     // this.veExAPI(countrypass).subscribe((data) => {
  //     //   console.log(data);
  //     //   this.countries = data.result.country;
  //     //   return this.countries;
  //     // });
  //   }
  //   return this.countries;
  // }
  getCountry(): Observable<any> {
    if (!this.countries) {
      console.log('Loading countries');
      
      const countrypass = {
        type: 'country_list',
        country: 'all'
      };
      
      this.countries = this._http.post(this.apistr, countrypass).pipe(
        shareReplay(1), // Cache the response and replay it for subsequent subscribers
        catchError(error => {
          console.error('Error fetching countries:', error);
          // You can choose to return a default value or throw the error here
          return of([]); // Return an empty array as a default value
        })
      );
    }
    return this.countries;
  }
}